import { httpsCallable } from "firebase/functions";
import { functions } from "@/lib/firebase";

const api = httpsCallable(functions, "api");
const publicApi = httpsCallable(functions, "publicApi");

export async function call<T, U>(action: string, payload: T): Promise<U> {
  const res = await api({ action, payload });
  return res.data as U;
}

export async function publicCall<T, U>(action: string, payload: T): Promise<U> {
  const res = await publicApi({ action, payload });
  return res.data as U;
}

// Generic types for course content that works with any platform
export type ImportedContentBlock = {
  id: string | number;
  title: string;
  videoUrl: string;
  description?: string;
  module?: string;
  path?: string; // For platforms that have custom paths
  rawTitle?: string; // Original title before processing
};

export async function importRawCourse({
  courseName,
  courseContent,
  schoolId,
}: {
  courseName: string;
  courseContent: ImportedContentBlock[];
  schoolId?: string;
}) {
  return call("importRawCourse", {
    courseName,
    courseContent,
    schoolId,
  });
}

export async function importYoutubeCourse({
  courseName,
  youtubeUrl,
  moduleRegex,
  blockRegex,
  schoolId,
}: {
  courseName: string;
  youtubeUrl: string;
  moduleRegex?: string;
  blockRegex?: string;
  schoolId?: string;
}) {
  return call("importYoutubeCourse", {
    courseName,
    youtubeUrl,
    moduleRegex,
    blockRegex,
    schoolId,
  });
}
